import { render, staticRenderFns } from "./RequirementAddModal.vue?vue&type=template&id=0b589f9f&"
import script from "./RequirementAddModal.vue?vue&type=script&lang=js&"
export * from "./RequirementAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RequirementAddModal.vue"
export default component.exports